import { ScmIntegrations } from '@backstage/integration';
import { createApiRef, useApp } from '@backstage/core-plugin-api';
import CodeIcon from '@material-ui/icons/Code';
import React from 'react';

class ScmIntegrationsApi {
  static fromConfig(config) {
    return ScmIntegrations.fromConfig(config);
  }
}
const scmIntegrationsApiRef = createApiRef({
  id: "integration.scmintegrations",
  description: "All of the registered SCM integrations of your config"
});

const ScmIntegrationIcon = ({type}) => {
  var _a;
  const app = useApp();
  const DefaultIcon = CodeIcon;
  const Icon = type ? (_a = app.getSystemIcon(type)) != null ? _a : DefaultIcon : DefaultIcon;
  return /* @__PURE__ */ React.createElement(Icon, null);
};

export { ScmIntegrationIcon, ScmIntegrationsApi, scmIntegrationsApiRef };
//# sourceMappingURL=index.esm.js.map
